import React, { useId } from 'react'
import { Defs, LinearGradient, Path, Stop, Svg } from 'react-native-svg'

function Logo({ className }: { className?: string }) {
  const id = useId()
  return (
    <Svg width={'80'} height={'80'} viewBox={'0 0 80 80'} fill={'none'} className={className}>
      <Path
        d={
          'M54.554 26.0719C52.7159 24.0982 50.0843 23.0605 47.3917 23.108L37.401 23.2708C37.2586 23.2775 37.1094 23.2843 36.967 23.2843C36.9263 23.2843 36.8856 23.2843 36.8449 23.2843H36.6617C36.5736 23.2843 36.4922 23.2775 36.4244 23.264C32.2599 22.9791 28.9704 19.52 28.9704 15.2878C28.9704 11.8355 31.1611 8.89186 34.2268 7.77275V7.74562C34.4439 7.68458 34.6541 7.63032 34.8508 7.57606C34.9051 7.56249 34.9593 7.54893 35.0136 7.52858C38.6355 6.5519 38.4998 6.44338 42.1624 6.61294C51.6714 7.10128 55.2526 19.6353 55.7341 28.0049C55.5917 27.3606 55.1373 26.6959 54.554 26.0651V26.0719Z'
        }
        fill={`url(#${id}_paint0_linear_37_578)`}
      />
      <Path
        d={
          'M40.2361 31.7488C40.2361 31.7488 39.9988 35.0723 37.5842 37.3376C35.1628 39.603 32.3074 39.8539 32.3074 39.8539C32.3074 39.8539 35.5969 40.383 37.4418 42.4109C39.2459 44.3982 39.9784 45.8225 40.304 47.7148C40.6295 45.8225 41.3959 44.3507 43.1323 42.3024C44.8754 40.2541 48.1784 39.8539 48.1784 39.8539C48.1784 39.8539 45.3162 39.603 42.9017 37.3376C40.4803 35.0723 40.2497 31.7488 40.2497 31.7488H40.2361Z'
        }
        fill={`url(#${id}_paint1_linear_37_578)`}
      />
      <Path
        fillRule={'evenodd'}
        clipRule={'evenodd'}
        d={
          'M24.3108 54.0158C25.3214 55.4876 27.0171 56.3354 28.8009 56.3897C33.0331 56.5118 47.1611 56.8305 51.3527 55.9624C51.4747 55.9352 51.5968 55.9081 51.7121 55.881C54.5133 55.1824 56.3988 52.5576 56.2903 49.675C56.1208 45.1172 55.5917 30.4941 55.646 28.4458C55.646 28.2966 55.6256 28.1406 55.5917 27.9846C55.1102 19.6353 51.5358 7.13519 42.0539 6.64685C60.6854 7.48788 72.609 22.4704 72.9007 39.759C73.1991 57.2646 58.4336 72.7016 40.2226 72.9932C40.2022 72.9932 40.1887 72.9864 40.1683 72.9797C40.1208 72.9661 40.0802 72.9525 40.0327 72.9457C27.7157 69.9343 24.5143 59.808 23.6055 52.5983C23.7886 53.1409 24.026 53.6156 24.3041 54.0158H24.3108Z'
        }
        fill={`url(#${id}_paint2_linear_37_578)`}
      />
      <Path
        d={
          'M20.3092 67.1195C2.54581 56.0573 6.68313 38.7687 7.49025 35.9743C8.33806 32.4881 11.5326 29.8972 15.3444 29.8972C19.1561 29.8972 22.0658 32.2575 23.0696 35.5063C23.0696 35.5199 23.0968 35.7302 23.0832 35.8048C23.1103 37.3919 23.2392 46.0396 23.307 50.4482C23.3206 51.2485 23.4495 51.9403 23.6462 52.5372C24.5618 59.8012 27.797 70.036 40.3175 72.9932C33.9013 73.0949 27.0645 71.3315 20.3024 67.1195H20.3092Z'
        }
        fill={`url(#${id}_paint3_linear_37_578)`}
      />
      <Path
        d={
          'M19.8615 12.5205C16.4024 12.5205 13.6013 9.71932 13.6013 6.26024C13.6013 2.80117 16.4092 0 19.8615 0C23.3138 0 26.1217 2.80117 26.1217 6.26024C26.1217 9.71932 23.3206 12.5205 19.8615 12.5205Z'
        }
        fill={`url(#${id}_paint4_linear_37_578)`}
      />
      <Path
        d={
          'M9.19254 23.3046C7.72074 23.3046 6.52023 22.1109 6.52023 20.6323C6.52023 19.1537 7.71395 17.96 9.19254 17.96C10.6711 17.96 11.8648 19.1537 11.8648 20.6323C11.8648 22.1109 10.6711 23.3046 9.19254 23.3046Z'
        }
        fill={`url(#${id}_paint5_linear_37_578)`}
      />
      <Path
        d={
          'M19.8615 16.1695C22.3303 16.1695 24.3244 18.1703 24.3244 20.6324C24.3244 23.0944 22.3236 25.0953 19.8615 25.0953C17.3995 25.0953 15.3986 23.0944 15.3986 20.6324C15.3986 18.1703 17.3995 16.1695 19.8615 16.1695Z'
        }
        fill={`url(#${id}_paint6_linear_37_578)`}
      />
      <Defs>
        <LinearGradient
          id={`${id}_paint0_linear_37_578`}
          x1={'28.9636'}
          y1={'17.2818'}
          x2={'55.7341'}
          y2={'17.2818'}
          gradientUnits={'userSpaceOnUse'}
        >
          <Stop stopColor={'#DABD94'} />
          <Stop offset={'1'} stopColor={'#AD8458'} />
        </LinearGradient>
        <LinearGradient
          id={`${id}_paint1_linear_37_578`}
          x1={'32.3006'}
          y1={'39.7318'}
          x2={'48.1717'}
          y2={'39.7318'}
          gradientUnits={'userSpaceOnUse'}
        >
          <Stop stopColor={'#DABD94'} />
          <Stop offset={'1'} stopColor={'#AD8458'} />
        </LinearGradient>
        <LinearGradient
          id={`${id}_paint2_linear_37_578`}
          x1={'67.4679'}
          y1={'20.0558'}
          x2={'25.0501'}
          y2={'62.4804'}
          gradientUnits={'userSpaceOnUse'}
        >
          <Stop stopColor={'#DABD94'} />
          <Stop offset={'1'} stopColor={'#AD8458'} />
        </LinearGradient>
        <LinearGradient
          id={`${id}_paint3_linear_37_578`}
          x1={'23.4156'}
          y1={'73'}
          x2={'23.4156'}
          y2={'29.8972'}
          gradientUnits={'userSpaceOnUse'}
        >
          <Stop stopColor={'#DABD94'} />
          <Stop offset={'1'} stopColor={'#AD8458'} />
        </LinearGradient>
        <LinearGradient
          id={`${id}_paint4_linear_37_578`}
          x1={'13.6013'}
          y1={'6.26024'}
          x2={'26.1217'}
          y2={'6.26024'}
          gradientUnits={'userSpaceOnUse'}
        >
          <Stop stopColor={'#DABD94'} />
          <Stop offset={'1'} stopColor={'#AD8458'} />
        </LinearGradient>
        <LinearGradient
          id={`${id}_paint5_linear_37_578`}
          x1={'6.52023'}
          y1={'20.6323'}
          x2={'11.8648'}
          y2={'20.6323'}
          gradientUnits={'userSpaceOnUse'}
        >
          <Stop stopColor={'#DABD94'} />
          <Stop offset={'1'} stopColor={'#AD8458'} />
        </LinearGradient>
        <LinearGradient
          id={`${id}_paint6_linear_37_578`}
          x1={'15.3986'}
          y1={'20.6324'}
          x2={'24.3312'}
          y2={'20.6324'}
          gradientUnits={'userSpaceOnUse'}
        >
          <Stop stopColor={'#DABD94'} />
          <Stop offset={'1'} stopColor={'#AD8458'} />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

export default Logo
